import { FontSpec } from './branding'

export const defaultFamilies = {
  sans:  'Overpass, Helvetica, Arial, sans-serif',
  mono:  'Menlo, Inconsolata, Roboto Mono, Courier New, monospace',
  hand:  'Comic Neue, Marker Felt, serif',
  chat:  'SF UI Display, Helvetica, Arial, sans-serif',
}

export function responsiveFontStyle(spec: FontSpec): Record<string, any> {
  const style: Record<string, any> = {
    font: {
      family: spec.family,
      weight: spec.weight,
      size:   spec.size,
    },
    lineHeight: spec.lineHeight,
  }

  if (spec.mobileSize != null) {
    style['@media screen and (max-width: 767px)'] = {
      font: { size: spec.mobileSize },
    }
  }

  return style
}